import { render, staticRenderFns } from "./IconSateliteTransmissao.vue?vue&type=template&id=671256f4&scoped=true"
import script from "./IconSateliteTransmissao.vue?vue&type=script&lang=js"
export * from "./IconSateliteTransmissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671256f4",
  null
  
)

export default component.exports